export default "__VITE_ASSET__e112d871__"